import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { api, assetUrl } from "@/lib/api";
import { CaretRight } from "@phosphor-icons/react";

export default function FeaturedStrips() {
  const [strips, setStrips] = useState([]);
  useEffect(() => { api.get("/public/featured").then((r) => setStrips(r.data.strips)).catch(() => {}); }, []);
  if (!strips.length) return null;
  return (
    <section className="mx-auto max-w-6xl px-5 pt-12" data-testid="featured-strips">
      {strips.map((s) => (
        <div key={s.key} className="mb-10" data-testid={`featured-${s.key}`}>
          <div className="mb-3 flex items-center justify-between">
            <h2 className="font-display text-xl font-black tracking-tight">{s.label}</h2>
            <Link to={`/explore?q=${encodeURIComponent(s.key.replace(/s$/, ""))}`}
              className="flex items-center gap-0.5 text-sm font-bold text-[#F27A54] hover:underline">
              See all <CaretRight size={14} weight="bold" />
            </Link>
          </div>
          <div className="flex gap-3 overflow-x-auto pb-2 [scrollbar-width:thin]">
            {s.photos.map((p) => (
              <Link key={p.id} to={`/p/${p.id}`} data-testid={`featured-photo-${p.id}`}
                className="group relative h-44 w-64 shrink-0 overflow-hidden rounded-lg bg-zinc-100 ring-1 ring-black/5">
                <img src={assetUrl(p.image_url)} alt={p.title} loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-2.5">
                  <p className="line-clamp-1 text-sm font-bold text-white">{p.title}</p>
                  {p.location?.city && <p className="text-xs text-white/75">{p.location.city}</p>}
                </div>
              </Link>
            ))}
          </div>
        </div>
      ))}
    </section>
  );
}
